import CookiesEuBanner from 'cookies-eu-banner';

const cookie = () => {
  const body = document.querySelector('body');

  const cookieBanner = CookiesEuBanner(() => {
    const tagmanager = document.createElement('script');

    tagmanager.setAttribute(
      'src',
      'https://www.googletagmanager.com/gtag/js?id=G-RRLXB213BG',
    );

    document.head.appendChild(tagmanager);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      // eslint-disable-next-line prefer-rest-params,no-undef
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-RRLXB213BG');

    body.classList.remove('u-cookie-pending');
  });

  const interval = setInterval(() => {
    if (!document.getElementById('cookies-eu-reject')) {
      body.classList.remove('u-cookie-pending');
      clearInterval(interval);
    }
  }, 500);

  if (!cookieBanner.hasConsent()) {
    body.classList.remove('u-cookie-pending');
  }
};

export default cookie;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/cookie.js